import supplieraddapply from '@/view/supplier-add';

const supplieradd = {
    install:function (Vue) {
        Vue.component('supplieradd',supplieraddapply)
    }
}
export default supplieradd;